import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { SiteList } from '../FormComponents';
import { SiteEntry } from '../../services/interfaces';
import { getUserList } from '../../services/apiAdminService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import UserProfileForm from "../UserProfileForm";
import { atolUser } from '../../services/interfaces';

interface userType{
    text:string
    value:string
}

interface searchField{
    text:string
    value:string
}

interface searchParams{
    searchFor:string
    userType:string
    field:string
    site:string
}

interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'fullName', dir: 'asc' }],
    skip:0,
    take:20
};

export default function UserManager (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [searchUser, setSearchUser]=useState("");
    const [searchType, setSearchType]=useState<userType>({ text: "All users", value: "All" });
    const [searchField, setSearchField]=useState<searchField>({ text: "User Name", value: "username" });
    const [searchSite, setSearchSite]=useState<SiteEntry[]>([]);
    const [users, setUsers] = useState([]);
    const [showContactCard,setShowContactCard]=useState(false);
    const [editProfileTitle,setEditProfileTitle]=useState("");
    
    const [selUser, setSelUser] = useState<atolUser>(
        {
            fullName:"",
            customer:"",
            email:"",
            phone:"",
            fax:"",
            userName:"",
            password:"",
            rep_id:0,
            security:0,
            temp1:"",
            temp2:"",
            temp3:"",
            temp4:"",
            temp5:"",
            temp6:"",
            temp7:"",
            salt:0,
            apiKey:"",
            proof_email:false,
            insert_email:false,
            submit_email:false,
            correction_email:false,
            approval_email:false,
            associations:"",
            trusted:1,
            superUser:false
        });
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(users,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const idGetter = getter('userName');
    const setUserType=(item:DropDownListChangeEvent)=>{
        setSearchType(item.value);
    }

    const setUserField=(item:DropDownListChangeEvent)=>{
       setSearchField(item.value);
    }

    const setUserSite = (sites: SiteEntry[]) => {
        setSearchSite(sites);
    }

    const setUserSearch = (val: InputChangeEvent) => {
        setSearchUser(val.value);
    }

    const setDialogTitle=(userName:string)=>{
        setEditProfileTitle("User Profile: " + userName);
    }

    const setSelectedUser=(user:atolUser)=>{
        setSelUser(user);
    }

    const userTypes:userType[]=[
        { text: "All users", value: "All" },
        { text: "Customer", value: "0" },
        { text: "Sales Rep", value: "1" },
        { text: "Sales Asst", value: "2" },
        { text: "Agency", value: "3" },
        { text: "Customer Service", value: "3C" },
        { text: "Manager", value: "4" },
        { text: "Administrator", value: "5" },
        { text: "DTO", value: "9" },
        { text: "Designer", value: "20" },
        { text: "MediaMagic", value: "40" },
        { text: "MediaMagic Admin", value: "41" }
    ]

    const searchFields:searchField[]=[
        { text: "User Name", value: "username" },
        { text: "Full Name", value: "FullName" },
        { text: "Customer", value: "customer" },
        { text: "Email", value: "Email" }
    ]

    const getUsers=()=>{
        const params:searchParams={
            searchFor:searchUser||"",
            field:searchField?.value||"",
            site: searchSite && searchSite.length > 0 ? searchSite[0].code : "",
            userType: searchType?.value||""
        }
        getUserList(params).then(data=>{
            setUsers(data);
            setDataResult(process(data, dataState));
        })
    }

    // const onDataStateChange = (e: GridDataStateChangeEvent) => {
    //     setDataState(e.dataState);
    //     setDataResult(process(users, e.dataState));
    // };

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        const NewDataState = {...e.dataState, skip:e.dataState.skip===undefined?0:e.dataState.skip, take:e.dataState.take===undefined?20:e.dataState.take}
        setDataState(NewDataState);
        const newStateData = process(users,NewDataState);
        setDataResult(newStateData);
    };
    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const newUser=()=>{
        setAction("New")
        setSelUser({
            fullName: "",
            customer: "",
            email: "",
            phone: "",
            fax: "",
            userName: "",
            password: "",
            rep_id: 0,
            security: 0,
            temp1: "",
            temp2: "",
            temp3: "",
            temp4: "",
            temp5: "",
            temp6: "",
            temp7: "",
            salt: 0,
            apiKey: "",
            proof_email: false,
            insert_email: false,
            submit_email: false,
            correction_email: false,
            approval_email: false,
            associations: "",
            trusted: 1,
            superUser: false
        });
        setShowContactCard(true);
    }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const user:atolUser=event.startDataItem;
        setAction("Edit");
        setSelectedUser(user);
        setDialogTitle(user.userName);
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "userName"
        });
        //console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
        //pageContext?.setSelectedAd(adRecord);
        setShowContactCard(true);
        };

    const hideContactInfo=()=>{
        setSelUser({
            fullName: "",
            customer: "",
            email: "",
            phone: "",
            fax: "",
            userName: "",
            password: "",
            rep_id: 0,
            security: 0,
            temp1: "",
            temp2: "",
            temp3: "",
            temp4: "",
            temp5: "",
            temp6: "",
            temp7: "",
            salt: 0,
            apiKey: "",
            proof_email: false,
            insert_email: false,
            submit_email: false,
            correction_email: false,
            approval_email: false,
            associations: "",
            trusted: 1,
            superUser: false
        });
        setShowContactCard(false);
        getUsers();
    }

    const formatCell=(e:GridCellProps)=>{
            const security=e.dataItem.type;
            var type="";
            switch (e.dataItem.security) {
                case 0:
                    type= "Customer";
                    break;
                case 1:
                    type= "Sales Rep";
                    break;
                case 2:
                    type= "Sales Asst";
                    break;
                case 3:                                
                    if (e.dataItem.temp2 == "C") {
                        type= "CS"
                    } else {
                        type= "Agency";
                    }
                    break;
                case 4:
                    type= "Manager";
                    break;
                case 5:
                    type= "Admin";
                    break;
                case 9:
                    type= "DTO";
                    break;
                case 20:
                    type= "Designer";
                    break;
                case 40:
                    type= "MediaMagic";
                    break;
                case 41:
                    type= "MediaMagic Admin";
                    break;
            }
            return(
                <td>
                    {type}
                </td>
            )
        }

    useEffect(() => {   
        if (user?.loggedIn){
            const handleKeyPress=(event: { key: string; })=>{
                if (event.key==="Enter"){
                    getUsers();
                }
            }

            document.addEventListener('keydown',handleKeyPress);
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn ?
        <Container fluid>
            <h2>User Manager</h2>
            <Toolbar>
                <ToolbarItem>
                    <label>Search For:</label>
                    <Input id="umSearchUsers" value={searchUser} onChange={setUserSearch}/>
                </ToolbarItem>
                <ToolbarItem>
                    <label>Type:</label>
                    <DropDownList value={searchType} data={userTypes} dataItemKey='value' textField='text' fillMode={"outline"} onChange={setUserType}></DropDownList>
                </ToolbarItem>
                <ToolbarItem>
                    <label>Field:</label>
                    <DropDownList value={searchField} data={searchFields} dataItemKey='value' textField='text' fillMode={"outline"} onChange={setUserField}></DropDownList>
                </ToolbarItem>
                <ToolbarItem>
                    <label>Site:</label><SiteList value={searchSite[0]} multi={false} setReturnAction={setUserSite} valid={true} className=''></SiteList>
                </ToolbarItem>
                <ToolbarItem>
                    <Button icon='search' onClick={getUsers}>Search</Button>
                </ToolbarItem>
                <ToolbarItem>
                    <Button icon='plus' onClick={newUser}>New User</Button>
                </ToolbarItem>
            </Toolbar>
            <Grid
                data={dataResult.data.map((item)=>({
                    ...item, 'selected':selectedState[idGetter(item)]
                }))}
                dataItemKey='userName'
                id="userGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                total={dataResult.total}
                onDataStateChange={onDataStateChange}
                //onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                reorderable={true}
                //selectedField={'selected'}
            >
                <GridColumn field='fullName' title='Full Name'/>
                <GridColumn field='userName' title='User Name'/>
                <GridColumn field='security' title='Type' cells={{data:formatCell}}/>
                <GridColumn field='customer' title='Customer/ID'/>
                <GridColumn field='temp4' title='Site'/>
                <GridColumn field='email' title='Email'/>                
            </Grid>
            {showContactCard?
                <UserProfileForm title={editProfileTitle} userProfile={selUser as atolUser} type={"Admin"} hideContactInfo={hideContactInfo} action={action}></UserProfileForm>
            :null
            }   
        </Container>
       
        : <></>}
        </>
    );
}